import AnimatedNumber from "@/components/common/AnimatedNumber";

// A segment's reach / impression count. null = the API could not read it
// (ClickHouse refused or failed the count): shown as unknown with the reason,
// never as 0.
export default function SegmentCount({ value, error, render }) {
  if (value === null || value === undefined) {
    const reason = error ? `Count unavailable: ${error}` : "Count unavailable";
    return (
      <span className="text-(--text-muted)" title={reason} aria-label={reason}>
        —
      </span>
    );
  }
  return render ? render(value) : <AnimatedNumber value={value} />;
}
